'use strict';

var _ = require('lodash');
var FlightLevelChartDataProviderService = function FlightLevelChartDataProviderService($filter, dataRetrieverService, analysisMetricService, representationService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var LY_FLIGHTS = 'LAST YEAR';
  function getSelectedMetric(screen, mode) {
    var dataRetriever = dataRetrieverService.getDataRetriever(screen, mode);
    var analysisMetric = analysisMetricService.getAnalysisMetric(screen);
    var labels = analysisMetric.getAvailableLabels(mode);
    return _.find(labels, {
      id: dataRetriever.selectedMetric()
    });
  }
  function getData(screen, mode, type, metric, dataRepresentation) {
    return dataRetrieverService.getDataRetriever(screen, mode).retrieveComponentData(type, metric).then(function (data) {
      if (!data) {
        return;
      }
      var preparedData = _.reduce(data, function (result, item) {
        item.flightLabel = item.isLastYearData ? LY_FLIGHTS : [item.flightNumber, item.opsSuffix, rmMomentFormat(item.legDepartureDateMoment, 'TIME_USER_SETTINGS')].join(' ');
        item.stackLabel = item.label;
        item = metric === 'loadFactor' ? representationService.prepareLFChartBarMetricsInAbsolute(item, dataRepresentation) : representationService.prepareChartBarMetrics(item, dataRepresentation);
        result[item.isLastYearData ? 'LY' : 'TY'].push(item);
        return result;
      }, {
        TY: [],
        LY: []
      });
      return [].concat(preparedData.TY, preparedData.LY);
    });
  }
  return {
    getData: getData,
    getSelectedMetric: getSelectedMetric
  };
};
FlightLevelChartDataProviderService.$inject = ['$filter', 'DataRetrieverService', 'AnalysisMetricService', 'DataRepresentationService'];
module.exports = FlightLevelChartDataProviderService;